export default function TodayPaperManager() { return <div>ই-পেপার</div>; }